/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BookingCancellationDisputeDto = {
    /**
     * Dispute UUID
     */
    id: string;
    /**
     * Dispute status
     */
    status: BookingCancellationDisputeDto.status;
    /**
     * Reason for cancellation
     */
    clientReason?: Record<string, any>;
    /**
     * Resolution notes from admin
     */
    resolutionNotes?: Record<string, any>;
    /**
     * When the request was raised
     */
    raisedAt?: Record<string, any>;
    /**
     * When it was resolved
     */
    resolvedAt?: Record<string, any>;
};
export namespace BookingCancellationDisputeDto {
    /**
     * Dispute status
     */
    export enum status {
        PENDING = 'pending',
        IN_REVIEW = 'in_review',
        RESOLVED = 'resolved',
        DECLINED = 'declined',
    }
}

